/***********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
2/20/19
HarvestAveragesSummary: Harvest averages for harvest dashboard
***********************************************************/
import React, { Component } from 'react';
import { Sparklines, SparklinesLine, SparklinesReferenceLine } from 'react-sparklines';

class HarvestAveragesSummary extends Component {
  render() {
    let { summary } = this.props.query;
    return (
      <ul className="collection z-depth-1 with-header">
        <li className="collection-item avatar">
          <i className="material-icons cyan circle">insert_chart</i>
          <p className="flow-text">Average Metrics</p>
          <p className>Employee Averages</p>
        </li>
        <li className="collection-item harvest-collection">
          <div className="row harvest-row">
            <div className="col s5 harvest-col-s6">
              <p className="harvest-collections-title">Average Cost per Acre</p>
              <p className="harvest-collections-content">${ summary.avgCostPerAcre}/acre</p>
            </div>
            <div className="col s3 harvest-col-s3">
              <span className="badge cyan white-text">Cost</span>
            </div>
            <div className="col s4 harvest-col-s3">
              <Sparklines data={summary.employee.map((e) => e.avgCostPerAcre)} height={20}>
                <SparklinesLine style={{ stroke: "blue", strokeWidth: "1", fill: "#00acc1", fillOpacity: "0.5" }}  />
                <SparklinesReferenceLine type="mean" />
              </Sparklines>
            </div>
          </div>
        </li>
        <li className="collection-item harvest-collection">
          <div className="row harvest-row">
            <div className="col s5 harvest-col-s6">
              <p className="harvest-collections-title">Average Density</p>
              <p className="harvest-collections-content">{ summary.avgDensity} lbs/tree</p>
            </div>
            <div className="col s3 harvest-col-s3">
              <span className="badge red white-text">Density</span>
            </div>
            <div className="col s4 harvest-col-s3">
              <Sparklines data={summary.employee.map((e) => e.avgDensity)} height={20}>
                <SparklinesLine style={{ stroke: "blue", strokeWidth: "1", fill: "#00acc1", fillOpacity: "0.5" }}  />
                <SparklinesReferenceLine type="mean" />
              </Sparklines>
            </div>
          </div>
        </li>
        <li className="collection-item harvest-collection">
          <div className="row harvest-row">
            <div className="col s5 harvest-col-s6">
              <p className="harvest-collections-title">Average Lbs per Hour</p>
              <p className="harvest-collections-content">{ summary.avgLbsPerHour} lbs/hr</p>
            </div>
            <div className="col s3 harvest-col-s3">
              <span className="badge green white-text">Lbs</span>
            </div>
            <div className="col s4 harvest-col-s3">
              <Sparklines data={summary.employee.map((e) => e.avgLbsPerHour)} height={20}>
                <SparklinesLine style={{ stroke: "blue", strokeWidth: "1", fill: "#00acc1", fillOpacity: "0.5" }}  />
                <SparklinesReferenceLine type="mean" />
              </Sparklines>
            </div>
          </div>
        </li>
        <li className="collection-item harvest-collection">
          <div className="row harvest-row">
            <div className="col s5 harvest-col-s6">
              <p className="harvest-collections-title">Average Trees per Hour</p>
              <p className="harvest-collections-content">{ summary.avgTreesPerHour} tree/acre</p>
            </div>
            <div className="col s3 harvest-col-s3">
              <span className="badge orange white-text">Trees</span>
            </div>
            <div className="col s4 harvest-col-s3">
              <Sparklines data={summary.employee.map((e) => e.avgTreesPerHour)} height={20}>
                <SparklinesLine style={{ stroke: "blue", strokeWidth: "1", fill: "#00acc1", fillOpacity: "0.5" }}  />
                <SparklinesReferenceLine type="mean" />
              </Sparklines>
            </div>
          </div>
        </li>
        <li className="collection-item harvest-collection">
          <div className="row harvest-row">
            <div className="col s5 harvest-col-s6">
              <p className="harvest-collections-title">Average Lbs per Acre</p>
              <p className="harvest-collections-content">{ summary.avgLbsPerAcre} lbs/acre</p>
            </div>
            <div className="col s3 harvest-col-s3">
              <span className="badge green white-text">Lbs</span>
            </div>
            <div className="col s4 harvest-col-s3">
              <Sparklines data={summary.employee.map((e) => e.avgLbsPerAcre)} height={20}>
                <SparklinesLine style={{ stroke: "blue", strokeWidth: "1", fill: "#00acc1", fillOpacity: "0.5" }}  />
                <SparklinesReferenceLine type="mean" />
              </Sparklines>
            </div>
          </div>
        </li>
        {
          summary.avgPerformanceIndex ?
          <li className="collection-item harvest-collection">
            <div className="row harvest-row">
              <div className="col s5 harvest-col-s6">
                <p className="harvest-collections-title">Average Performance Index</p>
                <p className="harvest-collections-content">{ summary.avgPerformanceIndex}</p>
              </div>
              <div className="col s3 harvest-col-s3">
                <span className="badge blue white-text">Performance</span>
              </div>
              <div className="col s4 harvest-col-s3">
                <Sparklines data={summary.employee.map((e) => e.avgPerformanceIndex)} height={20}>
                  <SparklinesLine style={{ stroke: "blue", strokeWidth: "1", fill: "#00acc1", fillOpacity: "0.5" }}  />
                  <SparklinesReferenceLine type="mean" />
                </Sparklines>
              </div>
            </div>
          </li> : ''
        }

      </ul>
    )
  }
}

export default HarvestAveragesSummary;




/* END */



// WEBPACK FOOTER //
// ./src/components/harvest/view/report/harvest_averages_summary.jsx